import axios from "axios"
import { API_HOST } from "../BaseUrl"
import client, { headers } from "./config"
import { encrypt, generateHMAC } from "../../Utils/hmac"



export const createPatientDetails = async (data) => {
    // console.log(data, "ddddd")
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `patient-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const getReviewReshootPatientDetails = async () => {
    // console.log(data, "ddddd")
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(API_HOST + `reshoot-details/${JSON.parse(localStorage.getItem("usertpi")).usertpi}`, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const getInsuranceClinicList = async () => {
    // console.log(data, "ddddd")
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        // "X-Rt": hmac.timestamp,
        // "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(API_HOST + `insurance/appointment-clinics-list`, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const checkClientByName = async (clientName) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(
                API_HOST + `insurance/client-name/${clientName}`,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const validateEmailInDatabase = async (email) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'application/json',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `validate-employee-email`, { email }, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const validateEmployeeEmail = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `validate-employee-email`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const markBeneficiaryCovered = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `mark-beneficiary-covered`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}